import Bowser from "bowser";

export function isSupportApp() {
  const browser = Bowser.parse(window.navigator.userAgent);
  const isSupport = ((browser.os?.name === 'Windows') || false && +(browser.os?.versionName || 0) >= 10) && (browser.platform?.type === 'desktop') || false;
  return isSupport;
}